import { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImage } from "../../../utils/getCroppedImage";
import "./ImageCropModal.scss";

const ASPECT = 16 / 9;

export default function ImageCropModal({ src, onCancel, onConfirm }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [processing, setProcessing] = useState(false);

  const onCropComplete = useCallback((_, pixels) => {
    setCroppedAreaPixels(pixels);
  }, []);

  async function handleConfirm() {
    if (!croppedAreaPixels) return;
    setProcessing(true);
    try {
      const blob = await getCroppedImage(src, croppedAreaPixels);
      const file = new File([blob], "header.jpg", { type: "image/jpeg" });
      onConfirm(file, URL.createObjectURL(blob));
    } finally {
      setProcessing(false);
    }
  }

  return (
    <div
      className="icm-backdrop"
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="icm">
        <div className="icm__header">
          <div className="icm__title-group">
            <h3 className="icm__title">Crop Header Image</h3>
            <span className="icm__hint">Ukuran ideal: 1600 × 900 px (16:9)</span>
          </div>
        </div>

        <div className="icm__canvas">
          <Cropper
            image={src}
            crop={crop}
            zoom={zoom}
            aspect={ASPECT}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            showGrid={false}
            style={{
              containerStyle: { borderRadius: "0" },
            }}
          />
        </div>

        <div className="icm__controls">
          <div className="icm__zoom">
            <span className="icm__zoom-label">Zoom</span>
            <input
              type="range"
              min={1}
              max={3}
              step={0.01}
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
              className="icm__zoom-slider"
            />
          </div>

          <div className="icm__actions">
            <button
              type="button"
              className="icm__btn icm__btn--cancel"
              onClick={onCancel}
              disabled={processing}
            >
              Batal
            </button>
            <button
              type="button"
              className="icm__btn icm__btn--confirm"
              onClick={handleConfirm}
              disabled={processing}
            >
              {processing ? "Memproses…" : "Gunakan Foto"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
